import { render, staticRenderFns } from "./PrintSaleDetail.vue?vue&type=template&id=bc592688"
import script from "./PrintSaleDetail.vue?vue&type=script&lang=js"
export * from "./PrintSaleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports